module.exports = __webpack_public_path__ + "img/photo9.b06340f5.png";